/* eslint-disable @typescript-eslint/dot-notation */
import * as Store from './Store';

const i: any = function() {
  i.c(arguments);
};

i.q = [];
i.c = function(args: any) {
  i.q.push(args);
};

(window as any).Intercom = i;

const getScript = (source: string, callback: () => any) => {
  const script = document.createElement('script');
  script.async = true;
  script.type = 'text/javascript';
  document.getElementsByTagName('head')[0].appendChild(script);

  script.onload = (): any => {
    callback();
  };

  script.src = source;
};

export const Load = (appId: string, wlId: number) => {
  getScript(`https://widget.intercom.io/widget/${appId}`, () => {
    if (window['Intercom']) {
      window['Intercom']('boot', {
        app_id: appId,
        user_id: null,
        email: null,
        name: null,
        whitelabelid: wlId,
        flipdishuserid: null,
        promotions_enabled: null,
        hide_default_launcher: true,
        phone: null,
      });
    }
  });
};

export const Update = (settings: Store.IntercomSettings) => {
  if (window['Intercom']) {
    window['Intercom']('update', settings);
  }
};

export const ShowMessages = (settings: Store.IntercomSettings) => {
  if (window['Intercom']) {
    window['Intercom']('showMessages', settings);
  }
};

export default Load;
/* eslint-enable @typescript-eslint/dot-notation */
